import { render, staticRenderFns } from "./courseLeadersFilters.vue?vue&type=template&id=06e647b6&scoped=true&lang=pug"
import script from "./courseLeadersFilters.vue?vue&type=script&lang=js"
export * from "./courseLeadersFilters.vue?vue&type=script&lang=js"
import style0 from "./courseLeadersFilters.vue?vue&type=style&index=0&id=06e647b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e647b6",
  null
  
)

export default component.exports